/** @jsxImportSource @emotion/react */
import Typography from '@mui/material/Typography'
import { useState } from 'react'
import { BaseModal } from 'components/Modals/BaseModal'
import { Category, CategoryInput, Form } from 'components/CreateCategoryModal/Form'
import * as classes from 'components/CreateCategoryModal/styles'

export type EditCategoryModalProps = {
  title: string
  open: boolean
  category: Category
  onClose: () => void
  onSubmit: (category: CategoryInput) => Promise<void>
  onRemove?: () => Promise<void>
}

export const EditCategoryModal = ({
  title,
  open,
  category,
  onClose,
  onSubmit,
  onRemove,
  ...props
}: EditCategoryModalProps) => {
  const [submitting, setSubmitting] = useState(false)

  const handleRemove = async () => {
    setSubmitting(true)
    try {
      await onRemove?.()
      onClose()
    } catch (e) {
      console.error('Question Bank Category remove failed:', e)
    }
    setSubmitting(false)
  }

  return (
    <BaseModal open={open} onClose={onClose} {...props}>
      <Typography css={classes.title} variant="title2">
        {title}
      </Typography>
      <Form
        category={category}
        onSubmit={onSubmit}
        onRemove={!onRemove ? undefined : handleRemove}
        submitting={submitting}
      />
    </BaseModal>
  )
}
